export enum TabSelect{
    None = 0,
    First = 1,
    Second = 2,
    Third = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tab-select.ts